export default __webpack_public_path__ + "static/media/object--support--traffic-sign-frame.7bae73cd.png";